import React, { useState, useEffect } from 'react';
import { tenantService } from '../../services/tenantService.ts';
import { formatCurrency, formatDate, formatPhoneNumber } from '../../utils/formatters.ts';

const OutstandingSettlements: React.FC = () => {
  const [settlements, setSettlements] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettlements();
  }, []);

  const fetchSettlements = async () => {
    try {
      const data = await tenantService.getOutstandingSettlements();
      // Filter settlements with outstanding amount > 0 and take 5 most recent
      const recentSettlements = data
        .filter(settlement => settlement.outstanding_amount > 0)
        .slice(0, 5);
      setSettlements(recentSettlements);
    } catch (error) {
      console.error('Error fetching settlements:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderOutstandingAmount = (amount: number) => {
    return (
      <td className={`amount-pending ${amount === 0 ? 'zero-amount' : ''}`}>
        {formatCurrency(amount)}
      </td>
    );
  };

  if (loading) return <div>Loading...</div>;
  if (settlements.length === 0) return null;

  return (
    <div className="dashboard-card outstanding-settlements">
      <div className="settlements-table">
        <h3>Recent Outstanding Settlements</h3>
        <div className="settlement-table-wrapper">
          <table className="desktop-only">
            <thead>
              <tr>
                <th>Tenant</th>
                <th>Property</th>
                <th>Contact</th>
                <th>Settlement Date</th>
                <th>Outstanding Amount</th>
              </tr>
            </thead>
            <tbody>
              {settlements.map((settlement) => (
                <tr key={settlement.id}>
                  <td>{settlement.tenant.full_name}</td>
                  <td>{settlement.property.name}</td>
                  <td>
                    {formatPhoneNumber(settlement.tenant.phone)}<br />
                    {settlement.tenant.email}
                  </td>
                  <td>{formatDate(settlement.settlement_date)}</td>
                  {renderOutstandingAmount(settlement.outstanding_amount)}
                </tr>
              ))}
            </tbody>
          </table>

          <div className="settlement-cards mobile-only">
            {settlements.map((settlement) => (
              <div key={settlement.id} className="settlement-card">
                <div className="settlement-card-header">
                  <span className="settlement-card-name">{settlement.tenant.full_name}</span>
                  <span className="settlement-card-date">{formatDate(settlement.settlement_date)}</span>
                </div>
                <div className="settlement-card-details">
                  <span>{settlement.property.name}</span>
                  <span>{formatPhoneNumber(settlement.tenant.phone)}</span>
                  <span>{settlement.tenant.email}</span>
                </div>
                <div className="settlement-card-amount">
                  Outstanding: {formatCurrency(settlement.outstanding_amount)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutstandingSettlements;
